import { Pipe, PipeTransform } from '@angular/core';

type RvbFormat = 'dollar' | 'percent' | 'year' | 'dollar-month' | 'compact';

@Pipe({ name: 'rvbFormat', standalone: true, pure: true })
export class RvbFormatPipe implements PipeTransform {
  transform(value: number, format: RvbFormat = 'dollar'): string {
    if (value == null || isNaN(value)) return '—';

    const abs = Math.abs(value);
    const sign = value < 0 ? '-' : '';

    switch (format) {
      case 'dollar':
        return sign + '$' + Math.round(abs).toLocaleString('en-US');

      case 'dollar-month':
        return sign + '$' + Math.round(abs).toLocaleString('en-US');

      case 'percent':
        // Show 1 decimal for whole numbers, 2 for fractional steps
        return value % 1 === 0
          ? value.toFixed(0) + '%'
          : value.toFixed(value % 0.5 === 0 ? 1 : 2) + '%';

      case 'year':
        return Math.round(value) + ' yr';

      case 'compact': {
        if (abs >= 1_000_000) return sign + '$' + (abs / 1_000_000).toFixed(2) + 'M';
        if (abs >= 1_000)     return sign + '$' + Math.round(abs / 1_000) + 'k';
        return sign + '$' + Math.round(abs);
      }

      default:
        return String(value);
    }
  }
}
